import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function clientexpectation() {
  return (
    <section className="client_expectation p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <StaticImage
              src="../../../images/case-studies/amj/client_exp.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["png"]}
              width={830}
              height={800}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>Client’s Expectations</h2>
            <p>
              The app had to have an interface, super-friendly and less
              distracting for corporate employees who already have stressful
              jobs. It had to be feature-packed, targeted at promoting wellness
              actions including: drinking enough water, exercising, taking time
              off the screens, participating in workouts, eating healthy
              breakfasts, lunches and dinners.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default clientexpectation;
